import {
  OAuthIntegrationPairingModal
} from './OAuthIntegrationPairingModal';
import {
  asanaService
} from "../services/api";
import {
  OnboardingEvents
} from '../analytics/posthog';

interface AsanaPairingModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
  existingLabels?: string[];
}

export function AsanaPairingModal({
  isOpen,
  onClose,
  onSuccess,
  existingLabels,
}: AsanaPairingModalProps) {
  return (
    <OAuthIntegrationPairingModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      existingLabels={existingLabels}
      name="asana"
      displayName="Asana"
      description="Connect your Asana account to manage tasks and projects directly in conversations."
      features={[
        'Search and browse your tasks',
        'Create and update tasks',
        'View upcoming due dates',
        'Manage task assignments and statuses',
      ]}
      accentColor="purple"
      events={{
        modalOpened: OnboardingEvents.ASANA_MODAL_OPENED,
        oauthStarted: OnboardingEvents.ASANA_OAUTH_STARTED,
        connected: OnboardingEvents.ASANA_CONNECTED,
        connectionFailed: OnboardingEvents.ASANA_CONNECTION_FAILED,
        modalClosed: OnboardingEvents.ASANA_MODAL_CLOSED,
      }}
      service={asanaService}
    />
  );
}
